import baseAPI from '@/http'

const router = 'api/eixosgrupos'

export const eixosGrupoAPI = {
    update: (configuracao) => baseAPI.put(router, configuracao),
    create: (configuracao) => baseAPI.post(router, configuracao),
    delete: (id) => baseAPI.delete(`${router}/${id}`),

    get: () => baseAPI.get(`${router}`),
}

